import { styled } from 'src/styles/stitches.config'

export const StyledFooter = styled('div', {
    paddingTop: '$lg',
    backgroundColor: '$background',
    paddingLeft: 'calc(2 * $colWidth)',
    paddingRight: 'calc(2 * $colWidth)',
    paddingBottom: '$lg',
})
